import { Component, ViewChild, Input, OnInit, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { AsideComponent } from '../aside/aside.component';
import { MatDialog, MatDialogConfig } from "@angular/material";
import { DialogDeleteShipComponent } from '../dialogs/dialog-delete-ship/dialog-delete-ship.component';
import { Ship } from '../../Models/ship';
import { DialogMoveShipComponent } from '../dialogs/dialog-move-ship/dialog-move-ship.component';
import { Load } from '../../Models/load';
import { VehicleShips } from '../../dtos/vehicle-ships';
import { Order } from '../../Models/order';
import { ApiHereService } from '../map/services/api.here.service';
import { OpenStreetMapService } from '../map/services/open-street-map.service';
import { Plant } from '../../Models/plant';
import { Address } from '../../Models/address';
import { LoadDto } from '../../dtos/load-dto';
import { DialogOptimizeComponent } from '../dialogs/dialog-optimize/dialog-optimize.component';
import { Vehicle } from 'src/app/Models/vehicle';
import { DialogPositionShipComponent } from '../dialogs/dialog-position-ship/dialog-position-ship.component';
import { HttpParams } from '@angular/common/http';
import { AlertType } from 'src/app/Models/alert-type';
import { AlertTypeEnum } from 'src/app/enums/alert-type-enum';
import { ApiService } from 'src/app/core/services/api.service';
import { MessageService } from 'src/app/core/services/message.service';
import { ShipStatusEnum } from 'src/app/enums/ship-status-enum';


@Component({
  selector: 'load-configuration-detail',
  templateUrl: './load-configuration-detail.component.html',
  styleUrls: ['./load-configuration-detail.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class LoadConfigurationDetailComponent implements OnInit {

  @ViewChild(AsideComponent) aside: AsideComponent;
  @Input() loadDto: LoadDto;
  load: Load;
  orders: Order[] = [];
  vehicles: any[] = [];
  shipsByVehicle: VehicleShips[] = [];
  selectedshipVehicle: VehicleShips;
  @Output() onClose: EventEmitter<boolean> = new EventEmitter<boolean>();
  start: Address;
  status = ShipStatusEnum;

  onlyUnique(value: any, index: any, self: any) {
    return self.indexOf(value) === index;
  }

  constructor(private dialog: MatDialog, private apiService: ApiService, private messageService: MessageService,
    private hereService: ApiHereService, private openStreetMapService: OpenStreetMapService) {
    
  }

  ngOnInit(): void {
    this.getLoad();
  }

  getLoad() {
    this.apiService.get('api/load/' + this.loadDto.id).subscribe(response => {
      if (response.data) {
        this.load = response.data;
        this.load.orders.sort(function (a, b) {
          return a.nOrder - b.nOrder;
        });
        this.orders = this.load.orders;
        this.getShipsByVehicle();
      }
    });
  }

  getAddress( idVehicle: number) {
    this.apiService.get('api/vehicle/getAddressByIdVehicle/' + idVehicle).subscribe(response => {
      if (response.data) {
 

      }
    });
  }


  openOptimizaDialog(vehicle: VehicleShips, indexVehicle: number) {
 
        this.start =  vehicle.orders[0].shipment.loadVehicle.plant.address;
  

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    let dialogRef = this.dialog.open(DialogOptimizeComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        let vehicles: Vehicle[] = data;
        this.optimizeVehicles(vehicles, vehicle, indexVehicle);
      }
    });
  }

  sendNotification(type: number) {
    let params: HttpParams = new HttpParams();
    params = params.append("alertType", type.toString());
    this.apiService.post('api/alert/SendNotification', null, params).subscribe(() => {

    });
  }


  optimizeVehicles(vehicles: Vehicle[], vehicleShip: VehicleShips, indexVehicle: number) {
    let deletedFirst: boolean = false;
    for (let itemVehicle of vehicles) {
      
      vehicleShip.orders = this.optimizeRoute(vehicleShip);
      let newVehicleShip: VehicleShips;
      let alreadyExist: boolean = false;
      this.shipsByVehicle.forEach(shipVehicle => {
        if (itemVehicle.registerNumber == shipVehicle.registerNumber) {
          newVehicleShip = shipVehicle;
          alreadyExist = true;
          return;
        }
      });
      if (!newVehicleShip) {
        newVehicleShip = new VehicleShips();
        newVehicleShip.orders = [];
      }

      if ((itemVehicle.capacity - newVehicleShip.orders.length) <= vehicleShip.orders.length) {
        for (let i = 0; i < itemVehicle.capacity - newVehicleShip.orders.length; i++) {
          newVehicleShip.registerNumber = itemVehicle.registerNumber;
          vehicleShip.orders[0].shipment.loadVehicle = itemVehicle;
          newVehicleShip.orders.push(vehicleShip.orders[0]);
          vehicleShip.orders.splice(0, 1);
        }
        newVehicleShip.orders = this.optimizeRoute(newVehicleShip);
        if (!alreadyExist) {
          this.shipsByVehicle.push(newVehicleShip);
        }
      } else {
        let lengthOrder = vehicleShip.orders.length;
        for (let i = 0; i < lengthOrder; i++) {
          newVehicleShip.registerNumber = itemVehicle.registerNumber;
          vehicleShip.orders[0].shipment.loadVehicle = itemVehicle;
          newVehicleShip.orders.push(vehicleShip.orders[0]);
          vehicleShip.orders.splice(0, 1);
        }
        newVehicleShip.orders = this.optimizeRoute(newVehicleShip);
        if (!alreadyExist) {
          this.shipsByVehicle.push(newVehicleShip);
        }
      }
      if (vehicleShip.orders.length == 0) {
        this.shipsByVehicle.splice(indexVehicle, 1);
        deletedFirst = true;
        break;
      }
    }
    if (!deletedFirst)
      this.optimizeRoute(vehicleShip);
    this.saveLoad();
    this.sendNotification(AlertTypeEnum.NEW_SCHEDULE_SHIP);
    this.sendNotification(AlertTypeEnum.LOAD);
  }

  movePosition(vehicle: VehicleShips, order: Order, indexVeh: number, indexShip: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    let position: number[] = [];
    vehicle.orders.forEach((item, index) => {
      position.push(index + 1);
    })
    dialogConfig.data = position;
    let dialogRef = this.dialog.open(DialogPositionShipComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        let positionShip: number = data;
        let tem: Order[];
        vehicle.orders.forEach((orderVehicle, index) => {
          if (orderVehicle.id == order.id) {
            tem = vehicle.orders.splice(index, 1);
          }
        });
        vehicle.orders.splice(positionShip - 1, 0, tem[0]);
        this.reOrderLoad(vehicle);
        this.saveLoad();
      }
    });
  }

  openDeleteDialog(vehicle: VehicleShips, order: Order, indexVeh: number, indexShip: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      shipToEliminate: order.shipment,
      loadId: this.load.id
    };
    let dialogRef = this.dialog.open(DialogDeleteShipComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        vehicle.orders.splice(indexShip, 1);
        if (vehicle.orders.length == 0)
          this.shipsByVehicle.splice(indexVeh, 1);
        this.load.orders.forEach((orderItem, index) => {
          if (orderItem.id == order.id) {
            this.load.orders.splice(index, 1);
            return;
          }
        });
        this.reOrderLoad(vehicle);
        this.sendNotification(AlertTypeEnum.NO_MERCHANDISE);
        this.messageService.success('GENERAL.MESSAGE.TITLE_SUCCESS', 'GENERAL.MESSAGE.SUCCESS',
          {
            article: 'GENERAL.MESSAGE.THE_1',
            function: 'DELIVERY_STORER.MESSAGES.FUNCTION_SHIP',
            action: 'DELIVERY_STORER.MESSAGES.ACTION_DELETE'
          });
      }
    });
  }

  reOrderLoad(vehicle: VehicleShips) {
    this.load.orders.forEach(orderLoad => {
      vehicle.orders.forEach((order, index) => {
        order.nOrder = index + 1;
        if (orderLoad.id == order.id) {
          orderLoad = order;
        }
      });
    });
  }

  openMoveDialog(vehicle: VehicleShips, order: Order, indexVeh: number, indexShip: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = order.shipment;
    let dialogRef = this.dialog.open(DialogMoveShipComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        let shipByVehExists: boolean = false;
        order.shipment = data;
        vehicle.orders.splice(indexShip, 1);
        if (vehicle.orders.length == 0) {
          this.shipsByVehicle.splice(indexVeh, 1);
        }
        if (vehicle.orders.length > 0) {
          this.reOrderLoad(vehicle);
        }
        this.shipsByVehicle.forEach(shipByVehicle => {
          if (shipByVehicle.registerNumber == order.shipment.loadVehicle.registerNumber) {
            shipByVehicle.orders.push(order);
            let orders = this.optimizeRoute(shipByVehicle);
            shipByVehicle.orders = orders;
            shipByVehExists = true;
          }
        });
        if (!shipByVehExists) {
          let tem: VehicleShips = new VehicleShips();
          tem.registerNumber = order.shipment.loadVehicle.registerNumber;
          tem.orders = [];
          order.nOrder = 1;
          tem.orders.push(order);
          this.shipsByVehicle.push(tem);
        }
        this.saveLoad();
        this.sendNotification(AlertTypeEnum.NEW_SCHEDULE_SHIP);
        this.sendNotification(AlertTypeEnum.LOAD);
        this.messageService.success('GENERAL.MESSAGE.TITLE_SUCCESS', 'GENERAL.MESSAGE.SUCCESS',
          {
            article: 'GENERAL.MESSAGE.THE_1',
            function: 'LOAD_CONFIGURATION_DETAIL.MOVEMENT',
            action: 'GENERAL.MESSAGE.ACTIONS.ACTION_DONE'
          });
      }
    });
  }

  open() {
    this.aside.open();
  }

  close() {
    this.onClose.emit(true);
  }

  getShipsByVehicle() {
    this.vehicles = this.load.orders.map((item) => item.shipment.loadVehicle.registerNumber).filter(this.onlyUnique);
    this.vehicles.forEach(vehicle => {
      let tem: VehicleShips = new VehicleShips();
      tem.registerNumber = vehicle;
      tem.orders = [];
      this.shipsByVehicle.push(tem);
    });
    this.shipsByVehicle.forEach(shipByVehicle => {
      this.load.orders.forEach(order => {
        if (order.shipment.loadVehicle.registerNumber == shipByVehicle.registerNumber && order.shipment.active) {
          shipByVehicle.orders.push(order);
        }
      });
    });
  }

  saveLoad() {
    this.apiService.put('api/load', this.load).subscribe((response: any) => {
      this.messageService.success('GENERAL.MESSAGE.TITLE_SUCCESS', 'GENERAL.MESSAGE.SUCCESS',
          {
            article: 'GENERAL.MESSAGE.THE_1',
            function: 'LOAD_CONFIGURATION_DETAIL.MOVEMENT',
            action: 'GENERAL.MESSAGE.ACTIONS.ACTION_DONE'
          });

    }, error => {
      this.messageService.error('GENERAL.MESSAGE.TITLE_ERROR', 'LOAD_CONFIGURATION_DETAIL.MESSAGE.LOAD_SAVE_ERROR');
    });
  }

  optimizeRoute(vehicle: VehicleShips) {
    this.start =  vehicle.orders[0].shipment.loadVehicle.plant.address;
    let orders = this.hereService.getShipSequenceByOrder(vehicle.orders, this.start);
    this.load.orders.forEach(item => {
      orders.forEach(order => {
        if (item.shipment.id == order.shipment.id) {
          item.nOrder = order.nOrder;
          item.shipment = order.shipment;
        }
      });
    });
    return orders;
  }
}
